import { useEffect, useState } from 'react'
import axios from 'axios'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { Button, Form } from 'react-bootstrap'
import FormContainer from '../components/FormContainer.js'
import Loader from '../components/Loader.js'
import Message from '../components/Message.js'
import { API_URL } from '../apiUrl.js'

const EmployeePasswordResetScreen = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const [employee, setEmployee] = useState(null)
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')

  useEffect(() => {
    let active = true
    axios
      .get(`${API_URL}/users/${id}/password`, { withCredentials: true })
      .then(({ data }) => {
        if (active) {
          setEmployee(data)
          setLoading(false)
        }
      })
      .catch((requestError) => {
        if (active) {
          setError(
            requestError.response?.data?.message ||
              'Could not load the employee account.'
          )
          setLoading(false)
        }
      })

    return () => {
      active = false
    }
  }, [id])

  const submitHandler = async (event) => {
    event.preventDefault()
    setError('')

    if (password.length < 6) {
      setError('Password must be at least 6 characters.')
      return
    }
    if (password !== confirmPassword) {
      setError('Passwords do not match.')
      return
    }

    setSaving(true)
    try {
      await axios.put(
        `${API_URL}/users/${id}/password`,
        { password },
        { withCredentials: true }
      )
      navigate('/admin/userlist')
    } catch (requestError) {
      setError(
        requestError.response?.data?.message ||
          'Could not reset the employee password.'
      )
      setSaving(false)
    }
  }

  return (
    <>
      <Link to='/admin/userlist' className='btn btn-outline-primary my-2'>
        Go Back
      </Link>
      <FormContainer>
        <h1>Reset employee password</h1>
        {loading ?
          <Loader />
        : error ?
          <Message variant='danger'>{error}</Message>
        : <>
            <p>
              Set a new password for {employee?.name} ({employee?.email}).
            </p>
            {error && <Message variant='danger'>{error}</Message>}
            <Form onSubmit={submitHandler}>
              <Form.Group className='mb-3' controlId='password'>
                <Form.Label>New password</Form.Label>
                <Form.Control
                  type='password'
                  autoComplete='new-password'
                  minLength={6}
                  required
                  value={password}
                  onChange={(event) => setPassword(event.target.value)}
                />
              </Form.Group>
              <Form.Group className='mb-3' controlId='confirmPassword'>
                <Form.Label>Confirm new password</Form.Label>
                <Form.Control
                  type='password'
                  autoComplete='new-password'
                  minLength={6}
                  required
                  value={confirmPassword}
                  onChange={(event) => setConfirmPassword(event.target.value)}
                />
              </Form.Group>
              <Button type='submit' disabled={saving}>
                {saving ? 'Saving…' : 'Reset password'}
              </Button>
            </Form>
          </>
        }
      </FormContainer>
    </>
  )
}

export default EmployeePasswordResetScreen
